<template>
  <el-menu :default-active="$route.path"
           background-color="#282828"
           text-color="#fff"
           active-text-color="#409eff"
           class="sidebar"
           :unique-opened="true"
           router>
    <el-menu-item index
                  class="header-container">
      <span class="header-title">
        <img :src="$root.base64_logo" @click="go_fullScreen" ref="logo" :style="{ height: $root.logo_height, width: $root.logo_width}"/> 
      </span>
    </el-menu-item>
    <slot></slot>
  </el-menu>
</template>

<script>
import bus from '@/utils/bus.js'
export default {
  methods: {
    // 点击logo跳转到大屏
    go_fullScreen () {
      this.$router.replace('/')
    }     
  }
}
</script>

<style scoped>
.header-container {
  height: 153px;
  text-align: center;
  border-bottom: rgba(255, 255, 255, 0.1);
}

.header-title {
  text-align: center;
  display: block;
  padding-top: 39px;
}


.sidebar {
  width: 200px !important;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow-y: auto;
  overflow-x: auto;
}

/*定义滚动条轨道 */
.sidebar::-webkit-scrollbar-track {
  border-radius: 10px;
  background: rgba(42, 42, 42, 1);
}

/*定义滑块*/
.sidebar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(136, 136, 136, 1);
}

.sidebar:hover::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/* 横向纵向滚动条相交的小方块样式 */
.sidebar:hover::-webkit-scrollbar-corner {
  background: rgba(42, 42, 42, 1);
}
.sidebar::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SidebarHeader.vue